module.exports = __webpack_public_path__ + "assets/images/CedarBar&Kitchenfa0e014a.png";